import { HJ_SHADOW_PREFIX } from '@hotjar/recordings/src/constants/shadow-dom';

/**
 * Return a selector removing it's index (0:) and any \ escaping characters.
 * @param selector Selector to clean.
 */
export const getCleanSelector = (selector?: string): string => {
  return (
    (selector && selector.split(/:(.*)/s)[1].replaceAll(HJ_SHADOW_PREFIX, '').replace(/\\/g, '')) ||
    ''
  );
};
